/*
* for Dark Mode:
* v-tooltip.bottom.isDarkMode="item.tooltip"
*/
export default {
  root: ({ context }) => {
    return {
      class: [
        // Position and Shadows
        'absolute',
        'bg-surface-700',
        'shadow-md',
        'p-fadein',
        'min-w-[200px]',
        'max-w-[250px]',
        'text-center',
        'rounded-md',

        {
          'my-2': context?.bottom || context?.top,
          'mx-2': context?.right || context?.left
        },

        // Spacing
        {
          'py-0 px-1': context?.right || context?.left || (!context?.right && !context?.left && !context?.top && !context?.bottom),
          'py-1 px-0': context?.top || context?.bottom
        },

        {
          'isDarkMode': context?.isDarkMode
        }
      ]
    }
  },
  arrow: ({ context }) => ({
    class: [
      // // Position
      // 'absolute',

      // // Size
      // 'w-0',
      // 'h-0',

      // // Shape
      // 'border-transparent',
      // 'border-solid',
      // {
      //   'border-y-[10px] border-r-[10px] border-l-0 border-r-white': context?.right || (!context?.right && !context?.left && !context?.top && !context?.bottom),
      //   'border-y-[10px] border-l-[10px] border-r-0 border-l-white': context?.left,
      //   'border-x-[10px] border-t-[10px] border-b-0 border-t-white': context?.top,
      //   'border-x-[10px] border-b-[10px] border-t-0 border-b-white': context?.bottom
      // },

      // // Spacing
      // {
      //   '-mt-[10px] top-1/2': context?.right || context?.left || (!context?.right && !context?.left && !context?.top && !context?.bottom),
      //   '-ml-[10px] left-1/2': context?.top || context?.bottom
      // }
    ]
  }),
  text: {
    class: [
      'py-1 px-2',
      'text-white', 
      'leading-none', 'rounded-md', 'whitespace-pre-line', 'break-words', 'text-[12px]', 'leading-relaxed', 'min-w-[100px]'
    ]
  }
}
